import api from '../client';

export const FilesService = {
  getRoot: () => api.get('/files/root'),
  getFolderById: (id) => api.get(`/files/folders/${id}`),
  createFolder: (data) => api.post('/files/folders', data),
  deleteFolder: (id) => api.delete(`/files/folders/${id}`),
  uploadFile: (folderId, title, fileType, projectId, taskId, description, data) => {
    let url = `/files/upload?folder_id=${folderId}&title=${encodeURIComponent(title)}&file_type=${encodeURIComponent(fileType)}`;
    if (projectId) url += `&project_id=${projectId}`;
    if (taskId) url += `&task_id=${taskId}`;
    if (description) url += `&description=${encodeURIComponent(description)}`;
    return api.post(url, data);
  },
  uploadChatFile: (roomId, title, fileType, projectId, description, data) => {
    let url = `/files/upload/chat?room_id=${roomId}&title=${encodeURIComponent(title)}&file_type=${encodeURIComponent(fileType)}`;
    if (projectId) url += `&project_id=${projectId}`;
    if (description) url += `&description=${encodeURIComponent(description)}`;
    return api.post(url, data);
  },
  getFileCard: (id) => api.get(`/files/${id}/card`),
  getFileContentText: (id) => api.get(`/files/${id}/content`, { responseType: 'text' }),
  getFileExcelData: (id) => api.get(`/files/${id}/excel-data`),
  updateFileExcelData: (id, data) => api.put(`/files/${id}/excel-data`, data),
  updateFileContent: (id, data) => api.put(`/files/${id}/content`, data),
  deleteFile: (id) => api.delete(`/files/${id}`),
  grantAccess: (id, data) => api.post(`/files/${id}/access`, data),
  revokeAccess: (id, userId) => api.delete(`/files/${id}/access/${userId}`),
  addComment: (id, data) => api.post(`/files/${id}/comments`, data),
  deleteComment: (id, commentId) => api.delete(`/files/${id}/comments/${commentId}`),
};
